import { useState } from "react";
import {
  Card,
  Collapse,
  Grid,
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import componentStyles from "assets/theme/views";
import { Pagination } from "@material-ui/lab";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import EditIcon from "@mui/icons-material/Edit";
import EditOffIcon from "@mui/icons-material/EditOff";
import CheckIcon from "@mui/icons-material/Check";
import BlockIcon from "@mui/icons-material/Block";
import VisibilityIcon from "@mui/icons-material/Visibility";

const useStyles = makeStyles({
  ...componentStyles,
  th: {
    color: "#32325d",
    fontSize: ".75rem",
    fontFamily: "inherit",
    fontWeight: 600,
    lineHeight: 1.5,
    marginBottom: ".5rem",
    textAlign: "center",
    padding: "15px 0",
  },
  td: {
    fontSize: ".75rem",
    fontFamily: "inherit",
    fontWeight: 500,
    textAlign: "center",
    padding: "10px 0px",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
  widthMedium: {
    width: "15vw",
    maxWidth: "15vw",
    textAlign: "center",
  },
  widthLarge: {
    width: "25vw",
    maxWidth: "25vw",
    height: "7vh",
    textAlign: "center",
  },
});

export default function TableSolicitacaoDevolucao({
  solicitacoesDevolucao,
  onApprove,
  onReject,
  setPage,
  totalPages,
  setSelectedSolicitation,
  setOpenVisibilityModal,
}) {
  const [openRows, setOpenRows] = useState({});

  const classes = useStyles();
  const sessionUserProfiles =
    JSON.parse(localStorage.getItem("userProfiles")) || [];

  const canApproveOrReject = sessionUserProfiles.some(
    (profile) => profile.NomePerfil === "CRC" || profile.NomePerfil === "ADM"
  );

  const extrairNotasFiscais = (data) => {
    const notasFiscaisUnicas = new Set();
    data.forEach((item) => {
      notasFiscaisUnicas.add(item.NumeroNota);
    });

    return Array.from(notasFiscaisUnicas).join(", ");
  };

  const toggleRow = (invoiceId) => {
    setOpenRows((prev) => ({
      ...prev,
      [invoiceId]: !prev[invoiceId],
    }));
  };

  return (
    <>
      <Card>
        <Grid item xs={12}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow style={{ borderBottom: "1px solid #ddd" }}>
                  <TableCell class={classes.th}></TableCell>
                  <TableCell class={classes.th}>Código Solicitacao</TableCell>
                  <TableCell class={classes.th}>Data Solicitação</TableCell>
                  <TableCell class={`${classes.th} ${classes.widthMedium}`}>
                    Nota Fiscal
                  </TableCell>
                  <TableCell class={classes.th}>Série</TableCell>
                  <TableCell class={classes.th}>Data Emissão</TableCell>
                  <TableCell class={classes.th}>Status</TableCell>
                  <TableCell class={classes.th}>Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {solicitacoesDevolucao?.map((solicitacao, index) => {
                  const id = solicitacao.Id || index;
                  const isOpen = !!openRows[id];
                  return (
                    <>
                      <TableRow
                        style={{ borderBottom: isOpen ? "" : "1px solid #ddd" }}
                      >
                        <TableCell class={classes.td}>
                          <Grid
                            item
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              padding: 0,
                            }}
                          >
                            <IconButton
                              aria-label="expand row"
                              size="small"
                              onClick={() => toggleRow(id)}
                            >
                              {isOpen ? (
                                <KeyboardArrowUpIcon />
                              ) : (
                                <KeyboardArrowDownIcon />
                              )}
                            </IconButton>
                          </Grid>
                        </TableCell>
                        <TableCell class={classes.td}>
                          {solicitacao.IdSolicitacao}
                        </TableCell>
                        <TableCell class={classes.td}>
                          {
                            solicitacao?.ListSolicitacaoItens[0]
                              ?.DataSolicitacaoFormat
                          }
                        </TableCell>
                        <TableCell class={classes.td}>
                          {extrairNotasFiscais(
                            solicitacao.ListSolicitacaoItens
                          )}
                        </TableCell>
                        <TableCell class={classes.td}>
                          {solicitacao?.Serie ? solicitacao.Serie : "-"}
                        </TableCell>
                        <TableCell class={classes.td}>
                          {solicitacao.DataEmissaoFormat}
                        </TableCell>
                        <TableCell
                          class={`{{${classes.td} ${classes.widthMedium}`}
                        >
                          {solicitacao?.StatusSolicitacao === "APROVADA" && (
                            <Typography
                              variant="caption"
                              style={{ color: "#2dce89" }}
                            >
                              APROVADA
                            </Typography>
                          )}
                          {solicitacao?.StatusSolicitacao === "REJEITADA" && (
                            <Typography variant="caption" color="error">
                              REJEITADA
                            </Typography>
                          )}
                          {!solicitacao?.StatusSolicitacao && (
                            <Typography variant="caption" color="textPrimary">
                              NÃO FINALIZADAS
                            </Typography>
                          )}
                          {solicitacao?.StatusSolicitacao === "ABERTA" && (
                            <Typography variant="caption" color="textPrimary">
                              PENDENTE
                            </Typography>
                          )}
                        </TableCell>
                        <TableCell
                          class={`{{${classes.td} ${classes.widthMedium}`}
                        >
                          <Grid container spacing={2}>
                            <Tooltip title="Vizualizar Solicitação">
                              <IconButton
                                onClick={() => {
                                  setSelectedSolicitation(solicitacao);
                                  setOpenVisibilityModal(true);
                                }}
                              >
                                <VisibilityIcon />
                              </IconButton>
                            </Tooltip>

                            {!solicitacao?.StatusSolicitacao ||
                            solicitacao.StatusSolicitacao === "ABERTA" ? (
                              <a
                                href={`/admin/solicitar-devolucao?${solicitacao.IdSolicitacao}`}
                              >
                                <Tooltip title="Editar Solicitação">
                                  <IconButton>
                                    <EditIcon />
                                  </IconButton>
                                </Tooltip>
                              </a>
                            ) : (
                              <Tooltip title="Não é possível editar a solicitação">
                                <IconButton disabled>
                                  <EditOffIcon />
                                </IconButton>
                              </Tooltip>
                            )}

                            {solicitacao?.StatusSolicitacao === "ABERTA" &&
                              canApproveOrReject && (
                                <>
                                  <Tooltip title="Aprovar Solicitação">
                                    <IconButton
                                      onClick={() => {
                                        onApprove();
                                        setSelectedSolicitation(solicitacao);
                                      }}
                                    >
                                      <CheckIcon />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Reprovar Solicitação">
                                    <IconButton
                                      onClick={() => {
                                        onReject();
                                        setSelectedSolicitation(solicitacao);
                                      }}
                                    >
                                      <BlockIcon />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              )}
                          </Grid>
                        </TableCell>
                      </TableRow>
                      {isOpen && (
                        <TableRow
                          style={{
                            borderBottom: "1px solid #ddd",
                            border: "none",
                          }}
                        >
                          <TableCell
                            colSpan={9}
                            style={{
                              padding: ".5rem 1rem",
                              borderTop: "none",
                            }}
                          >
                            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                              <TableContainer>
                                <Table
                                  style={{
                                    border: "1px solid #ddd",
                                    borderRadius: "15px",
                                  }}
                                >
                                  <TableHead>
                                    <TableRow
                                      style={{ borderBottom: "1px solid #ddd" }}
                                    >
                                      <TableCell class={classes.th}>
                                        Código Produto
                                      </TableCell>
                                      <TableCell
                                        class={`${classes.th} ${classes.widthMedium}`}
                                      >
                                        Descrição Produto
                                      </TableCell>
                                      <TableCell class={classes.th}>
                                        Saldo
                                      </TableCell>
                                      <TableCell class={classes.th}>
                                        Nota Fiscal
                                      </TableCell>
                                      <TableCell class={classes.th}>
                                        Serie
                                      </TableCell>
                                      <TableCell class={classes.th}>
                                        Quantidade Devolução
                                      </TableCell>
                                      <TableCell
                                        class={`${classes.th} ${classes.widthMedium}`}
                                      >
                                        Motivo Devolução
                                      </TableCell>
                                      <TableCell
                                        class={`${classes.th} ${classes.widthMedium}`}
                                      >
                                        Motivo Defeito
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {solicitacao?.ListSolicitacaoItens?.map(
                                      (item) => (
                                        <TableRow
                                          style={{
                                            borderBottom: "1px solid #ddd",
                                          }}
                                          key={item.Id}
                                        >
                                          <TableCell class={classes.td}>
                                            {item.IdProduto}
                                          </TableCell>
                                          <TableCell class={classes.td}>
                                            {item.NomeProduto}
                                          </TableCell>
                                          <TableCell class={classes.td}>
                                            {item.QuantidadeNF}
                                          </TableCell>
                                          <TableCell class={classes.td}>
                                            {item.NumeroNota}
                                          </TableCell>
                                          <TableCell class={classes.td}>
                                            {item.Serie}
                                          </TableCell>
                                          <TableCell class={classes.td}>
                                            {item.Quantidade}
                                          </TableCell>
                                          <TableCell class={classes.td}>
                                            {item.Motivo}
                                          </TableCell>
                                          <TableCell class={classes.td}>
                                            {item.Defeito}
                                          </TableCell>
                                        </TableRow>
                                      )
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      )}
                    </>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <Grid item sx={12}>
            <Pagination
              count={totalPages}
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "20px 0",
              }}
              color="primary"
              variant="outlined"
              onChange={(e, page) => {
                setPage(page);
              }}
            />
          </Grid>
        </Grid>
      </Card>
    </>
  );
}
